<template>
   <div class="post__comment post__comment--main" :class="{'post__comment--main': !parentNode, 'post__comment--response': parentNode}">
        <textarea  
            name="textarea-post-comment" 
            class="post__comment--textarea" 
            :class="{'post__comment--textarea-main': !parentNode, 'post__comment--textarea-response': parentNode}"
            :placeholder="t('commentPlaceholder')" 
            v-model="newComment"></textarea>
        <button class="post__comment--submit btn btn--blue" @click="postComment">
            <loading-button :loading="submittingComment">{{t('publish')}}</loading-button>
        </button>
    </div>
</template>

<script>
import { ref } from 'vue';
import { useStore } from 'vuex';

import axios from 'axios';
import LoadingButton from '../utils/LoadingButton';

import {useI18n} from 'vue-i18n';

import en from "@/locales/en/post/post.json";
import fr from "@/locales/fr/post/post.json";

export default {
    components: {LoadingButton},
    props:{
        collection:{
            type: String
        },
        reference:{
            type:String
        }, 
        parentNode:{
            type:String,
            default: null
        },
    },
    setup(props, {emit}){
        const {t} = useI18n({
            messages:{
                en: en,
                fr: fr
                }
        })

        const store = useStore();

        const newComment = ref(null);
        const submittingComment = ref(false);

        const postComment = async () => {
            if(store.state.loggedIn){
                if(newComment.value && !submittingComment.value){
                    submittingComment.value = true;

                    const data = {
                                comment: newComment.value,
                                onCollection: props.collection,
                                reference: props.reference
                            }
                    if(props.parentNode){
                        data.parentComment = props.parentNode
                    }

                    try{
                        const res = await axios({
                            method:'POST',
                            url:'comments',
                            data
                        })
                        if(res.status == '201'){
                            submittingComment.value = false;
                            const comm = res.data.data.data;
                            comm.response = [];
                            comm.createdBy = store.state.user;
                            
                            emit('newCommentPost',  comm)

                            //Reset Form
                            newComment.value = '';

                            // ACTION EVERYTHING IS GOOD
                            store.dispatch('showAction',{message: "Your comment has been published in the comment section.", color: 'green'})
                        }
                    }catch(err){
                        console.log(err);
                        console.log(err.response)
                    }
                }
            }else{
                store.commit("showSignupPopup");
            }
        }
        return {newComment, postComment,submittingComment, t}
    },
    emits:['newCommentPost']
}
</script>

<style lang="scss" scoped>
@import '../../style/main';
.post{
        &__comment{
        
        width: 100%;
        display: flex;
        flex-direction: column;


        &--textarea{
            margin-bottom: 1.4rem;
            padding: 1rem;
            font-size: 1.4rem;
            box-shadow: $shadow;
            border: 1px solid $color-grey-50;
            outline: none;
            resize: none;
           

            &-main{
                height: 12rem;
            }
            &-response{
                height: 6rem;
            }
        }
        &--submit{
            align-self: flex-start;
            font-size: 1.4rem !important;
            padding: .8rem 2rem !important; 
        }

        &--main{
            margin: 4rem 0;
        }

        &--response{
            margin: 1.5rem 0;
        }
    }
}
</style>